// Build a query to the API search service
export default class SearchQueryBuilder {
  constructor() {
    this.parts = [];
  }

  toString() {
    return this.parts.join(' ').trim();
  }

  append(term) {
    this.parts = this.parts.concat(term);
    return this;
  }

  appendSearchText(text) {
    text = (text || '').trim();
    if (isAdvancedQuery(text)) {
      // advanced mode detected
      this.append(text);
      return this;
    } else {
      splitQuoted(text).forEach((term) => {
        this.append(term);
      });
      return this;
    }
  }
}

function isAdvancedQuery(text) {
  // check if user is trying an advanced feature.  if so, we won't try
  // to interpret as a simple query
  return text.indexOf('starts_at:') >= 0;
}

function splitSimple(text) {
  return text.split(' ');
}

function splitQuoted(text) {
  let result = [];
  let words = splitSimple(text);
  let phrase = null;
  words.forEach((word) => {
    if (!phrase && word.startsWith('"')) {
      // start of phrase
      if (word.endsWith('"')) {
        // single-word phrase
        phrase = '+' + word;
        result.push(phrase);
        phrase = null;
      } else {
        // multi-word phrase (need to keep looping)
        phrase = '+' + word;
      }
    } else if (phrase && word.endsWith('"')) {
      // end of current phrase
      phrase += ' ' + word;
      result.push(phrase);
      phrase = null;
    } else if (phrase) {
      // keep building...
      phrase += ' ' + word;
    } else {
      // just a plain word
      word = `+*${word}*`;
      result.push(word);
    }
  });

  if (phrase) {
    // fix unbalanced quote
    phrase += '"';
    result.push(phrase);
  }

  return result;
}



// WEBPACK FOOTER //
// ./app/utils/search-query-builder.js